import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export const RELOCATION_ORDER_UNLOAD_LOCATIONS_RESOURCE = "relocation-order" as const;
export const RELOCATION_ORDER_UNLOAD_LOCATIONS_OPERATION = "unload-locations" as const;
export const RELOCATION_ORDER_UNLOAD_LOCATIONS_API_PATH =
  `/v1/${RELOCATION_ORDER_UNLOAD_LOCATIONS_RESOURCE}/${RELOCATION_ORDER_UNLOAD_LOCATIONS_OPERATION}` as const;

export type UnloadLocationsBody =
  paths[typeof RELOCATION_ORDER_UNLOAD_LOCATIONS_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type UnloadLocationsResponse =
  paths[typeof RELOCATION_ORDER_UNLOAD_LOCATIONS_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export function useRelocationOrderUnloadLocationsQuery(
  body?: UnloadLocationsBody,
  queryOptions?: Omit<
    UseQueryOptions<UnloadLocationsResponse, Error, UnloadLocationsResponse, readonly unknown[]>,
    "queryKey" | "queryFn"
  >,
) {
  const requestBody = body ?? {};

  return useQuery({
    queryKey: [
      RELOCATION_ORDER_UNLOAD_LOCATIONS_RESOURCE,
      RELOCATION_ORDER_UNLOAD_LOCATIONS_OPERATION,
      { body: requestBody },
    ],
    queryFn: async () => {
      const response = await alphartisApiAxios.post<UnloadLocationsResponse>(
        RELOCATION_ORDER_UNLOAD_LOCATIONS_API_PATH,
        requestBody,
      );

      return response.data;
    },
    ...queryOptions,
  });
}
